import {Locale} from '@aboutyou/legacy-shared/src/types/locale';

export const uspLinks: Record<Locale, string> = {
  [Locale.de_DE]: '/h/versand-lieferung-/q-360014777500',
  [Locale.en_DE]: '/h/shipping-delivery/q-360014777500',
  [Locale.de_AT]: '/h/versand-lieferung-/q-360014777500',
  [Locale.en_AT]: '/h/shipping-delivery/q-360014777500',
  [Locale.de_CH]: '',
  [Locale.fr_CH]: '',
  [Locale.en_CH]: '/h/shipping-delivery/q-360014777500',
  [Locale.nl_NL]: '/h/verzending-levering/q-360014777500',
  [Locale.en_NL]: '/h/shipping-delivery/q-360014777500',
  [Locale.nl_BE]: '/h/verzending-levering/q-360014777500',
  [Locale.fr_BE]: '/h/expedition-livraison/q-360014777500',
  [Locale.pl_PL]: '/h/wysylka-dostawa/q-360014777500',
  [Locale.cs_CZ]: '/h/doruceni/q-360014777500',
  [Locale.sk_SK]: '/h/doprava-a-dorucenie/q-360014777500',
  [Locale.hu_HU]: '/h/szallitas-kezbesites/q-360014777500',
  [Locale.ro_RO]: '/h/livrare/q-360014777500',
  [Locale.et_EE]: '/h/tarne-kohaletoimetamine/q-360014777500',
  [Locale.lv_LV]: '/h/piegade/q-360014777500',
  [Locale.lt_LT]: '/h/pristatymas/q-360014777500',
  [Locale.sl_SI]: '/h/posiljanje-dostava/q-360014777500',
  [Locale.hr_HR]: '/h/dostava/q-360014777500',
  [Locale.bg_BG]: '/h/shipping-delivery/q-360014777500',
  [Locale.fr_FR]: '/h/expedition-livraison/q-360014777500',
  [Locale.sv_SE]: '/h/foersaendelser-och-leverans/q-360014777500',
  [Locale.da_DK]: '/h/forsendelse-og-levering/q-360014777500',
  [Locale.fi_FI]: '/h/toimitus/q-360014777500',
  [Locale.it_IT]: '/h/spedizione-consegna/q-360014777500',
  [Locale.it_CH]: '/h/spedizione-consegna/q-360014777500',
  [Locale.es_ES]: '/h/envio-y-entrega/q-360014777500',
  [Locale.pt_PT]: '',
  [Locale.el_GR]: '',
  [Locale.en_ZZ]: '',
  [Locale.es_ZZ]: '',
  [Locale.el_CY]: '',
  [Locale.fr_LU]: '',
  [Locale.ru_EE]: '/h/dostavka/q-360014777500',
  [Locale.ru_LV]: '/h/dostavka/q-360014777500',
};
